import React from "react"
import { useShallow } from "zustand/react/shallow"
import { Collapse, Typography, Tooltip, Flex } from "antd"
import ValidationOrganizer from "./components/ValidationOrganizer/ValidationOrganizer"
import "./ValidationPanel.scss"

// @ts-ignore
import useAuthoringViewStore from "../../hooks/stores/useAuthoringViewStore"

const { Text } = Typography

const ValidationPanel = ({ validations }: { validations: any }) => {
  const { formSection } = useAuthoringViewStore(
    useShallow((state: any) => ({
      formSection: state.formSection,
    }))
  )

  const items = React.useMemo(() => {
    const values = []

    if (validations?.validations?.length > 0) {
      const filteredValidations =
        validations?.validations?.filter((msg: any) => {
          if (formSection.id === "protocol" && msg.field_key.startsWith("protocol")) {
            return true
          } else if (formSection.id === "results" && msg.field_key.startsWith("results")) {
            return true
          } else if (
            formSection.id === "delayedResultsCertification" &&
            msg.field_key.startsWith("delayed_results_certification")
          ) {
            return true
          }
        }) || []
      values.push({
        key: "validations",
        label: <Text strong>Mapped Validations ({filteredValidations.length})</Text>,
        children: (
          <ValidationOrganizer
            validations={filteredValidations}
            type="mapped"
          />
        ),
      })
    }

    if (validations?.unmapped_validations?.length > 0) {
      values.push({
        key: "unmappedValidations",
        label: (
          <Flex
            gap={4}
            align="center"
          >
            <Text strong>Unmapped Validations ({validations.unmapped_validations.length})</Text>
            <Tooltip
              title={
                "These validations could not be mapped to a specific field or section in the form. If you believe this field is present and should be mapped, please use the 'Suggest a Feature' button to report it to our support team."
              }
            >
              <i
                className="fa-sharp fa-light fa-circle-info"
                style={{ marginTop: 2 }}
              />
            </Tooltip>
          </Flex>
        ),
        children: (
          <ValidationOrganizer
            validations={
              validations?.unmapped_validations?.map((item: any) => ({
                field_key: item.source || item?.location,
                type: item.severity || item.type?.toUpperCase(),
                text: item.message,
              })) || []
            }
            type="unmapped"
          />
        ),
      })
    }

    return values
  }, [validations, formSection?.id])

  return (
    <Collapse
      bordered={false}
      expandIcon={({ isActive }) => <i className={`fa-light fa-angle-${isActive ? "down" : "right"}`} />}
      style={{ background: "transparent", marginLeft: 18 }}
      items={items}
    />
  )
}

export default ValidationPanel
